import React from "react";
import Slider from "react-slick";
import {
  Box,
  Grid,
  Typography,
  Button,
  Avatar,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  ArrowForwardIos,
  ArrowBackIos,
  Grain,
  LocationOn,
  DesignServices,
  Security,
} from "@mui/icons-material";
import { motion } from "framer-motion";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Images
import whiteonionbanner from './images/whiteonionbanner.jpg';
import webdesign from './images/webdesign.jpg'
import webdevelopment from './images/webdev.png'
import logodesign from './images/logo desgin.jpg'
import digitalmarketing from './images/digitalmarketing.jpg'
import pinkOnionFlakeImage from './images/Dehydrated Onion Flakes Supplier, Exporter _ Dehydratedveg_com.jpeg'
import garlicCloveImage from './images/GarlicClove.jpg'
import garlicChoppedImage from './images/GarlicMinced.jpeg'
import garlicMincedImage from './images/how-to-mince-garlic-2171-1.jpg'
import garlicGranulesImage from './images/GarlicGranules.jpg'
import garlicpowderimg from './images/garlicpowder.jpg'
import pinkOnionGranulesImage from './images/PinkOnionGranules.webp'
import pinkOnionChoppedImage from './images/purple-onion-cut-half-pink-strips-visible-against-dark-background-344354882.webp'
import pinkOnionMincedImage from './images/pinkonionminced.jpg'
import pinkOnionPowderImage from './images/pinkonionpowder.jpg'
import whiteOnionFlakeImage from './images/whiteonionflakes.webp'
import whiteOnionGranulesImage from './images/whiteoniongranules.jpeg'
import whiteOnionChoppedImage from './images/dehydrated-white-onion-chopped-500x500.webp'
import whiteOnionMincedImage from './images/dehydrated-white-onion-minced-500x500.webp'
import whiteOnionPowderImage from './images/dehydrated-white-onion-powder.jpg'
import redOnionFlakeImage from './images/redonionflakes.webp'
import redOnionGranulesImage from './images/dehydrated-red-onion-granules-0-2-1-mm.jpg'
import redOnionChoppedImage from './images/red-onion-chopped-2-scaled-500x500.webp'
import redOnionMincedImage from './images/dehydrated-red-onion-minced-500x500.webp'
import redOnionPowderImage from './images/redonionpowder.jpg'
import friedOnionFreshImage from './images/organic-onion-fried-500x500.webp'
import friedCoatedWhiteOnionImage from './images/whitecoatedonion.webp'
import friedCoatedPinkOnionImage from './images/pink-coated-fried-onion.jpg'
import friedWhiteOnionFlakeImage from './images/friedcoatedmin.jpg'
import friedPinkOnionFlakeImage from './images/friedcoatedmin.jpg'
import gingerFlakeImage from './images/dehydrated-ginger-flakes.jpg'
import gingerPowderImage from './images/113563735.webp'
import greenChilliPowderImage from './images/dehydrated-green-chilli-powder-500x500.webp'
import tamarindPowderImage from './images/tamarind-powder-500x500.webp'
import tomatoPowderImage from './images/toamatopowder.jpg'
import mintPowderImage from './images/mint-leaves-pudina-patta-powder-2nd.jpeg'
import potatoPowderImage from './images/istockphoto-185902790-612x612.jpg'
import spinachPowderImage from './images/spinachpowder.jpg'
import mangoPowderImage from './images/AmchurPowder.webp'
import fenugreekPowderImage from './images/7d59b4210bfcc07bb28cdba3eae734816bdc8e06_1024x1024.webp'
import lemonPowderImage from './images/07_Spray-Dried-Lemon-Powder-600x600.jpg'
import beetrootPowderImage from './images/DriedBeetrootPowder.webp'
import cheesePowderImage from './images/IMG_6946_800x.webp'
import corianderPowderImage from './images/CorianderPowder.webp'
import beetrootImage from './images/istockphoto-493446908-612x612.jpg'
import cabbageImage from './images/istockphoto-544313316-612x612.jpg'
import carrotImage from './images/carrots.jpg'
import tomatoImage from './images/istockphoto-98026003-612x612.jpg'
import gingerImage from './images/istockphoto-162711007-612x612.jpg'
import potatoImage from './images/istockphoto-1346299887-612x612.jpg'
import greenChilliImage  from './images/green-chilli-200-g-product-images-o590000187-p590000187-0-202409251830.webp'

// Components
import Commonredirects from "./Commonredirects";
import FeatureProduct from "./FeatureProduct";

// Theme Colors
const primaryColor = "#1F473E";
const secondaryColor = "#D4C9B6";

// Animation
const floatAnimation = {
  animate: {
    y: [0, -10, 0],
    transition: {
      duration: 2,
      repeat: Infinity,
      ease: "easeInOut",
    },
  },
};

// Custom Arrows
const NextArrow = ({ onClick }) => (
  <ArrowForwardIos
    onClick={onClick}
    sx={{
      position: "absolute",
      top: "50%",
      right: "15px",
      zIndex: 10,
      cursor: "pointer",
      fontSize: 40,
      color: secondaryColor,
      background: primaryColor,
      borderRadius: "50%",
      padding: "5px",
      transition: "0.3s",
      "&:hover": {
        transform: "scale(1.2)",
        background: secondaryColor,
        color: primaryColor,
      },
    }}
  />
);

const PrevArrow = ({ onClick }) => (
  <ArrowBackIos
    onClick={onClick}
    sx={{
      position: "absolute",
      top: "50%",
      left: "15px",
      zIndex: 10,
      cursor: "pointer",
      fontSize: 40,
      color: secondaryColor,
      background: primaryColor,
      borderRadius: "50%",
      padding: "5px",
      transition: "0.3s",
      "&:hover": {
        transform: "scale(1.2)",
        background: secondaryColor,
        color: primaryColor,
      },
    }}
  />
);

const DetailedProductGarlic = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const slides = [
    {
      image: whiteonionbanner,
      title: "Garlic Products",
      description:
        "Experience the bold flavor and enticing aroma of our premium organic garlic, carefully harvested from the finest farms to ensure unmatched freshness and quality.",
      buttonText: "Order Now",
    },
  ];



const garlicClove = {
  image: garlicCloveImage,
  features: [
    {
      icon: Grain,
      title: "Garlic Clove",
      description:
        "Whole dehydrated garlic cloves. Perfect for adding strong garlic flavor to dishes with convenience and long shelf life.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description:
        "Form: Whole Cloves. Color: Natural pale yellow. Purity: 100%. Shelf Life: 12 months. Packaging: Sealed food-safe bags.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description:
        "Naturally dried garlic cloves, retaining flavor and aroma. Ideal for long-term storage and versatile culinary use.",
    },
    {
      icon: Security,
      title: "About the Product",
      description:
        "Great for pickling, grinding into powder, or using whole in stews, soups, and marinades.",
    },
  ],
};

const garlicChopped = {
  image: garlicChoppedImage,
  features: [
    {
      icon: Grain,
      title: "Garlic Chopped (3–5 mm)",
      description:
        "Coarsely chopped dehydrated garlic. Ideal for recipes that need texture and bite with garlic aroma.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description:
        "Form: Chopped. Particle Size: 3–5 mm. Purity: 100%. Shelf Life: 12 months. Color: Creamy white.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description:
        "Made from high-quality garlic, chopped and dried for consistent size and flavor.",
    },
    {
      icon: Security,
      title: "About the Product",
      description:
        "Commonly used in spice blends, ready meals, and sauces where visible garlic pieces are desirable.",
    },
  ],
};

const garlicMinced = {
  image: garlicMincedImage,
  features: [
    {
      icon: Grain,
      title: "Garlic Minced (1–3 mm)",
      description:
        "Finely minced dehydrated garlic. Even distribution and concentrated flavor for rubs, blends, and seasoning mixes.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description:
        "Form: Minced. Particle Size: 1–3 mm. Color: Off-white. Purity: 100%. Shelf Life: 12 months.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description:
        "Finely chopped and dehydrated garlic perfect for spice rubs, instant food kits, and processed seasonings.",
    },
    {
      icon: Security,
      title: "About the Product",
      description:
        "Offers uniform garlic flavor across dishes. Ideal for dry rubs and seasoning packets.",
    },
  ],
};

const garlicGranules = {
  image: garlicGranulesImage,
  features: [
    {
      icon: Grain,
      title: "Garlic Granules (0.5–1 mm)",
      description:
        "Granulated garlic for versatile cooking. Great for seasoning blends, sauces, and spice applications.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description:
        "Form: Granules. Size: 0.5–1 mm. Color: Pale ivory. Purity: 100%. Shelf Life: 12 months.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description:
        "Uniform granulation for even blending. Easy to use in spice mixes, sauces, or as a standalone seasoning.",
    },
    {
      icon: Security,
      title: "About the Product",
      description:
        "Preferred in industrial kitchens and food manufacturing for consistency and flavor control.",
    },
  ],
};

const garlicPowder = {
  image: garlicpowderimg,
  features: [
    {
      icon: Grain,
      title: "Garlic Powder",
      description:
        "Aromatic fine powder made from dehydrated garlic cloves. Convenient, shelf-stable option for seasoning with intense garlic flavor.",
    },
    {
      icon: LocationOn,
      title: "Specifications",
      description:
        "Form: Fine powder. Mesh Size: 80–100. Color: Off-white. Purity: 100%. Shelf Life: 12 months.",
    },
    {
      icon: DesignServices,
      title: "Product Details",
      description:
        "Made by finely grinding dehydrated garlic cloves. Consistent, potent garlic flavor ideal for dry mixes and sauces.",
    },
    {
      icon: Security,
      title: "About the Product",
      description:
        "Used widely in spice blends, seasoning packs, instant foods, and fast-cooking recipes.",
    },
  ],
};




  return (
    <>
      {/* Hero Slider */}
      <Box sx={{ width: "100%", height: "90vh", overflow: "hidden", position: "relative" }}>
        <Slider {...settings}>
          {slides.map((slide, index) => (
            <Box
              key={index}
              sx={{
                height: "90vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: `url(${slide.image}) center/cover no-repeat`,
                width: "100%",
              }}
            >
              <Box
                sx={{
                  background: "rgba(31, 71, 62, 0.3)",
                  color: secondaryColor,
                  padding: "20%",
                  borderRadius: "10px",
                  textAlign: "center",
                  boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                }}
              >
                <motion.div variants={floatAnimation} animate="animate">
                  <Typography variant="h2" sx={{ fontFamily: "'Playfair Display', serif", fontWeight: "bold", mb: 2 }}>
                    {slide.title}
                  </Typography>
                </motion.div>
                <motion.div variants={floatAnimation} animate="animate">
                  <Typography variant="h5" sx={{ fontFamily: "'Playfair Display', serif", mb: 3 }}>
                    {slide.description}
                  </Typography>
                </motion.div>
                <motion.div variants={floatAnimation} animate="animate">
                  <Button
                    variant="contained"
                    sx={{ backgroundColor: secondaryColor, color: primaryColor, fontWeight: "bold" }}
                  >
                    {slide.buttonText}
                  </Button>
                </motion.div>
              </Box>
            </Box>
          ))}
        </Slider>
      </Box>

      {/* Product Details Section */}
      <FeatureProduct data={garlicClove} title={"Garlic Cloves"} />
            <FeatureProduct data={garlicChopped} title={"Chopped Garlic"} />

      <FeatureProduct data={garlicMinced} title={"Minced Garlic"} />

      <FeatureProduct data={garlicGranules} title={"Garlic Granules"} />

      <FeatureProduct data={garlicPowder} title={"Garlic Powder"} />

    

      <Commonredirects />
    </>
  );
};

export default DetailedProductGarlic;
